import { Component } from "react"
import PropTypes from "prop-types"

import PopulatorValue from "./populator_value"
import { StatusRow } from "./table_components"
import { findFieldTypeDescriptionByID } from "partners/components/shared/stencilable_field_types"

class ActionField extends Component {
  renderAttributes() {
    const { actionField, feedbackItems = {}, diffStyle, pathObjs } = this.props
    let attributes = [
      {
        key: `action-field-item-name-${actionField.id}`,
        name: "Label",
        value: actionField.name,
        required: true,
        fieldName: "name",
      },
      {
        key: `action-field-item-helper-text-${actionField.id}`,
        name: "Optional helper text",
        value: actionField.helper_text,
        fieldName: "helper_text",
      },
      {
        key: `action-field-item-slug-${actionField.id}`,
        name: "Key name",
        value: actionField.slug,
        required: true,
        fieldName: "slug",
      },
      {
        key: `action-field-shareable-${actionField.id}`,
        name: "Private?",
        value: actionField.shareable,
        fieldName: "shareable",
        transform: value => (value ? "No" : "Yes"),
      },
      {
        key: `action-field-item-required-${actionField.id}`,
        name: "Required?",
        value: actionField.required,
        transform: value => (value ? "Yes" : "No"),
        fieldName: "required",
      },
      {
        key: `action-field-item-field-type-${actionField.id}`,
        name: "Field Type",
        value: actionField.action_field_type,
        transform: findFieldTypeDescriptionByID,
        fieldName: "action_field_type",
      },
    ]

    if (actionField.action_field_type === 14 || actionField.action_field_type === 19) {
      const diffs = this.props.changes.filter(diff => diff.path[4] === "populator_values")
      const originalChannel = this.props.originalChannel
      attributes = attributes.concat({
        key: "action-field-item-populator-values",
        name: "Dropdown Options",
        value: actionField.populator_values,
        transform: value => (
          <PopulatorValue
            diffStyle={diffStyle}
            originalChannel={originalChannel}
            values={value}
            changes={diffs}
            parent="actions"
            collection="action_fields"
          />
        ),
        fieldName: "populator_values",
      })
    }

    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return attributes.map(item => {
      item.feedback = feedbackItems[item.fieldName]
      item.pathObjs = [...pathObjs, actionField.id, item.fieldName]
      item.diff = this.props.changes.find(
        diff => diff.data && diff.data.property === item.fieldName && diff.path.length === 4
      )
      if (item.feedback && !submenuIcons.actionsFeedback) {
        this.props.setSessionFeedback("actions", submenuIcons)
      }
      return this.props.tableRow(item)
    })
  }

  render() {
    return (
      <table className="subtable">
        <tbody>
          {this.props.diffStyle !== "none" && <StatusRow status={this.props.status} />}
          {this.renderAttributes()}
        </tbody>
      </table>
    )
  }
}

ActionField.propTypes = {
  diffStyle: PropTypes.string.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  pathObjs: PropTypes.array.isRequired,
  actionField: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default ActionField
